export default class SlideshowManager {
  constructor() {
    this.intervalId = null; // Track interval ID
    this.startSlideshow();
  }

  switchToNextSlide() {
    const element = document.querySelector('[data-hero-image].opacity-100');
    if (!element) return;

    const parent = element.parentElement;
    const nextSibling = element.nextElementSibling || parent.firstElementChild;

    // Toggle opacity classes
    element.classList.toggle('opacity-100');
    element.classList.toggle('opacity-0');
    nextSibling.classList.toggle('opacity-100');
    nextSibling.classList.toggle('opacity-0');
  }

  startSlideshow() {
    const heroImages = document.querySelectorAll('[data-hero-image]');

    if (heroImages.length > 0) {
      if (this.intervalId) {
        clearInterval(this.intervalId); // Clear previous interval
      }
      this.intervalId = setInterval(this.switchToNextSlide.bind(this), 5000);
    }
  }
}
